/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { Container, MapTo } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';
import {
  EditableHTLWrapper,
  StaticWrapper,
  LinkList,
  AccordionContainer,
  CardCarouselContainer,
  CardVertical,
  Hero,
  CardLayered,
  CardHorizontalMini,
  CardHorizontalFeature,
  Mosaic,
  RichText,
  BannerLayered,
  BrandRibbon,
  IconBlock,
  CobrandCardHorizontalFlexible,
  LinkBanner,
  GeneralMessage,
  VariableColumnContainer,
  BannerText,
  CarouselGallery,
  DataBlock,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  AccordionContainerEnhanced,
  BannerFeature,
  TabContainer,
  CardSummary,
  Text,
  Media,
} from '@marriott/mi-common-static-components';
import {
  OfferDetails,
  OffersHero,
  OffersSearchFormWrapper,
  OfferCardCarousel,
  OfferCardListing,
  OffersAemText,
  OffersBrandRibbon,
  OfferPropertiesList,
  PreviewContainer,
  OutletOfferResult,
  OfferCardHorizontalMini,
  OffersHeroBanner,
  OffersBannerLayered,
  OffersCobrandCardHorizontalFlexible,
  OffersHeroV2,
  OffersCardLayered,
  NearByDestinations,
  OffersSearchResults,
  OffersVariableColumnContainer,
  OfferCards,
  OffersMerchandisingHeroBanner,
  OffersMerchandisingSmallBanner,
  ExploreDestinations,
  OnOffContainer,
  OffersMBEHero,
  BrandedLogoBar,
  TabbedProperties,
  OffersAccordionContainerEnhanced,
} from '@marriott/mi-offers-components';
import { HotelHeaderComponentEditable } from '@marriott/mi-book-components/organisms';
import { HeroBanner } from '@marriott/mi-homepage-components';
import { SearchFormEditable } from '@marriott/mi-shop-components';
import { AppSmallBanner, OffersAppContainer } from '@marriott/mi-mobile-offers-preview-components';
const { NEXT_PUBLIC_AEM_SITE } = process.env;

export const AEM_REACT_MAPPING = {
  //common component mapping
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/hero`]: OffersHeroV2,
  [`mi-aem-common-spa/components/content/cardlayered`]: OffersCardLayered,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: OfferCardHorizontalMini,
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: CardHorizontalFeature,
  [`mi-aem-common-spa/components/content/mosaic`]: Mosaic,
  [`mi-aem-common-spa/components/content/richtext`]: RichText,
  [`mi-aem-common-spa/components/content/bannerlayered`]: OffersBannerLayered,
  [`mi-aem-common-spa/components/content/iconblock`]: IconBlock,
  [`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`]: OffersCobrandCardHorizontalFlexible,
  [`mi-aem-common-spa/components/content/linkbanner`]: LinkBanner,
  [`mi-aem-common-spa/components/content/generalmessage`]: GeneralMessage,
  [`mi-aem-common-spa/components/content/variablecolumncontainer`]: VariableColumnContainer,
  [`mi-aem-common-spa/components/content/variablecolumncontainer`]: OffersVariableColumnContainer,
  [`mi-aem-common-spa/components/content/brandribbon`]: OffersBrandRibbon,
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/content/linklist`]: LinkList,
  ['mi-aem-common-spa/components/content/offersappcontainer']: OffersAppContainer,
  [`mi-aem-common-spa/components/content/accordioncontainer`]: AccordionContainer,
  [`mi-aem-common-spa/components/content/accordioncontainerenhanced`]: AccordionContainerEnhanced,
  [`mi-aem-common-spa/components/content/bannertext`]: BannerText,
  [`mi-aem-common-spa/components/content/carouselgallery`]: CarouselGallery,
  [`mi-aem-common-spa/components/content/datablock`]: DataBlock,
  [`mi-aem-common-spa/components/content/bannerfeature`]: BannerFeature,
  [`mi-aem-common-spa/components/content/tabcontainer`]: TabContainer,
  ['mi-aem-common-spa/components/content/media']: Media,
  [`mi-aem-common-spa/components/content/cardsummary`]: CardSummary,
  [`mi-aem-common-spa/components/content/text`]: Text,
  [`mi-aem-common-spa/components/content/merchandisingsmallbanner`]: OffersMerchandisingSmallBanner,
  [`mi-aem-common-spa/components/content/merchandisingherobanner`]: OffersMerchandisingHeroBanner,

  //Other squad components mapping
  [`mcom-book-spa/components/prebooking/hotelheader`]: HotelHeaderComponentEditable,
  [`mi-aem-homepage-spa/components/content/herobanner`]: OffersHeroBanner,
  [`mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform`]: SearchFormEditable,
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,

  //offers component maping
  [`mi-aem-offers-spa/components/text`]: OffersAemText,
  [`mi-aem-offers-spa/components/offers-details`]: OfferDetails,
  [`mi-aem-offers-spa/components/offers-hero`]: OffersHero,
  [`mi-aem-offers-spa/components/offers-searchform`]: OffersSearchFormWrapper,
  [`mi-aem-offers-spa/components/offers-cards`]: OfferCardCarousel,
  [`mi-aem-offers-spa/components/offers-cards-list`]: OfferCardListing,
  [`mi-aem-offers-spa/components/offers-properties-list`]: OfferPropertiesList,
  [`mi-aem-offers-spa/components/previewcontainer`]: PreviewContainer,
  [`mi-aem-offers-spa/components/outletofferresults`]: OutletOfferResult,
  [`mi-aem-offers-spa/components/nearbydestinations`]: NearByDestinations,
  [`mi-aem-offers-spa/components/offerssearchresults`]: OffersSearchResults,
  [`mi-aem-offers-spa/components/offerscardstiles`]: OfferCards,
  [`mi-aem-offers-spa/components/exploredestinations`]: ExploreDestinations,
  [`mi-aem-offers-spa/components/onoffcontainer`]: OnOffContainer,
  [`mi-aem-offers-spa/components/mbehero`]: OffersMBEHero,
  [`mi-aem-offers-spa/components/brandedlogobar`]: BrandedLogoBar,
  [`mi-aem-offers-spa/components/tabbedproperties`]: TabbedProperties,
  [`mi-aem-offers-spa/components/offerscardhorizontalmini`]: OfferCardHorizontalMini,
  [`mi-aem-offers-spa/components/offerscardlayered`]: OffersCardLayered,
  [`mi-aem-offers-spa/components/offersbannerlayered`]: OffersBannerLayered,
  [`mi-aem-offers-spa/components/offersherobanner`]: OffersHeroBanner,
  [`mi-aem-offers-spa/components/offerscobrandcardhorizontalflexible`]: OffersCobrandCardHorizontalFlexible,
  [`mi-aem-offers-spa/components/offershero`]: OffersHeroV2,
  [`mi-aem-offers-spa/components/offersvariablecolumncontainer`]: OffersVariableColumnContainer,
  [`mi-aem-offers-spa/components/offersaccordioncontainerenhanced`]: OffersAccordionContainerEnhanced,
  ['mi-aem-common-spa/components/content/appsmallbanner']: AppSmallBanner,
};

export const defineComponentMapping = (allowedComponents, pageProps, isAuthorMode) => {
  const mathType = pageProps.productSpecificResponse?.responseObject?.edges[0]?.merchandisingNode?.mathType;
  MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper, {
    emptyLabel: 'StaticWrapper',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(CardHorizontalFeature);
  MapTo(`mi-aem-common-spa/components/content/mosaic`)(Mosaic);
  MapTo(`mi-aem-common-spa/components/content/richtext`)(RichText);
  MapTo(`mi-aem-common-spa/components/content/iconblock`)(IconBlock);
  MapTo(`mi-aem-common-spa/components/content/linkbanner`)(LinkBanner);
  MapTo(`mi-aem-common-spa/components/content/generalmessage`)(GeneralMessage);
  // validate if the mathType includes "Points"
  const shouldRenderMerchHeroBanner = mathType ? ['Points'].includes(mathType[0]) : false;
  MapTo(`mi-aem-common-spa/components/content/merchandisingherobanner`)(
    props =>
      shouldRenderMerchHeroBanner || isAuthorMode ? (
        <OffersMerchandisingHeroBanner
          {...props}
          isAuthorMode={isAuthorMode}
          offersData={pageProps.productSpecificResponse}
        />
      ) : (
        ''
      ),
    {
      emptyLabel: 'MerchandisingHeroBanner',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/variablecolumncontainer`)(props => (
    <div className={`${props?.model?.appliedCssClassNames ?? 'mb-5'}`}>
      {(props.model?.path).split('/').pop().startsWith('offers') ? (
        <OffersVariableColumnContainer
          {...props}
          offersData={pageProps.productSpecificResponse}
          isAuthorMode={isAuthorMode}
          allowedComponents={allowedComponents}
        />
      ) : (
        <VariableColumnContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
      )}
    </div>
  ));
  MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(props => (
    <CardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/offersappcontainer`)(
    props => (
      <OffersAppContainer {...props} isAuthorMode={isAuthorMode} offersData={pageProps.productSpecificResponse} />
    ),
    {
      emptyLabel: 'Offers App Container',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/cardvertical`)(CardVertical);
  MapTo(`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`)(
    props => (
      <div className={`${props?.model?.appliedCssClassNames ?? 'mb-5'}`}>
        {(props.model?.path).split('/').pop().startsWith('offers') ? (
          <OffersCobrandCardHorizontalFlexible
            {...props}
            isAuthorMode={isAuthorMode}
            offersData={pageProps.productSpecificResponse}
          />
        ) : (
          <CobrandCardHorizontalFlexible {...props} />
        )}
      </div>
    ),
    {
      emptyLabel: 'Offers Cobrand Card Horizontal Flexible',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/cardlayered`)(
    props => (
      <div className={`${props?.model?.appliedCssClassNames ?? 'pb-5 mb-5'}`}>
        {(props.model?.path).split('/').pop().startsWith('offers') ? (
          <OffersCardLayered {...props} isAuthorMode={isAuthorMode} offersData={pageProps.productSpecificResponse} />
        ) : (
          <CardLayered {...props} />
        )}
      </div>
    ),
    {
      emptyLabel: 'Offers Card Layerd',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/brandribbon`)(
    props => (
      <div
        className={`${props?.model?.appliedCssClassNames ?? 'standard pb-5'}`}
        style={{
          'margin-top': '-2rem',
        }}
      >
        <OffersBrandRibbon {...props} offersData={pageProps.productSpecificResponse} isAuthorMode={isAuthorMode} />
      </div>
    ),
    {
      emptyLabel: 'Offers Brand logos',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/cardsummary`)(CardSummary);
  MapTo(`mi-aem-common-spa/components/content/linklist`)(LinkList);
  MapTo(`mi-aem-common-spa/components/content/accordioncontainer`)(props => (
    <div
      className={`${props?.model?.appliedCssClassNames ?? 'standard'}`}
      style={{
        'pointer-events': pageProps?.productSpecificResponse?.isPreview === 'true' ? 'none' : 'auto',
      }}
    >
      <AccordionContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    </div>
  ));
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(
    props => (
      <div className={`${props?.model?.appliedCssClassNames ?? 'pb-5'}`}>
        {(props.model?.path).split('/').pop().startsWith('offers') ? (
          <OfferCardHorizontalMini
            {...props}
            offersData={pageProps.productSpecificResponse}
            isAuthorMode={isAuthorMode}
          />
        ) : (
          <CardHorizontalMini {...props} />
        )}
      </div>
    ),
    {
      emptyLabel: 'Offers Card Horizontal Mini',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(
    props => (
      <div className={`${props?.model?.appliedCssClassNames ?? ''}`}>
        {(props.model?.path).split('/').pop().startsWith('offers') ? (
          <OffersBannerLayered {...props} isAuthorMode={isAuthorMode} offersData={pageProps.productSpecificResponse} />
        ) : (
          <BannerLayered {...props} />
        )}
      </div>
    ),
    {
      emptyLabel: 'Offers Banner Layered',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/hero`)(
    props => (
      <div className={`${props?.model?.styleclass ?? 'mb-5 pb-5'}`}>
        {(props.model?.path).split('/').pop().startsWith('offers') ? (
          <OffersHeroV2 {...props} isAuthorMode={isAuthorMode} offersData={pageProps.productSpecificResponse} />
        ) : (
          <Hero {...props} />
        )}
      </div>
    ),
    {
      emptyLabel: 'Offers Hero Banner V2',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/bannertext`)(BannerText);
  MapTo(`mi-aem-common-spa/components/content/carouselgallery`)(CarouselGallery);
  MapTo(`mi-aem-common-spa/components/content/datablock`)(DataBlock);
  MapTo(`mi-aem-common-spa/components/content/tabcontainer`)(props => (
    <TabContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/media`)(props => (
    <Media {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/accordioncontainerenhanced`)(props => (
    <AccordionContainerEnhanced {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-offers-spa/components/offersaccordioncontainerenhanced`)(props => (
    <div className={`${props?.model?.appliedCssClassNames}`}>
      <OffersAccordionContainerEnhanced {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    </div>
  ));
  MapTo(`mi-aem-common-spa/components/content/bannerfeature`)(props => <BannerFeature {...props} />);
  MapTo(`mi-aem-common-spa/components/content/text`)(props => <Text {...props} />);
  const shouldRenderMerchSmallBanner = mathType ? ['Points', 'Currency'].includes(mathType[0]) : false;
  MapTo(`mi-aem-common-spa/components/content/merchandisingsmallbanner`)(
    props =>
      shouldRenderMerchSmallBanner || isAuthorMode ? (
        <OffersMerchandisingSmallBanner
          {...props}
          isAuthorMode={isAuthorMode}
          offersData={pageProps.productSpecificResponse}
        />
      ) : (
        ''
      ),
    {
      emptyLabel: 'MerchandisingSmallBanner',
      isEmpty: false,
    }
  );

  //Offers components
  MapTo(`mi-aem-offers-spa/components/offers-properties-list`)(
    props => (
      <OfferPropertiesList
        {...props}
        offersData={pageProps.productSpecificResponse}
        isAuthorMode={isAuthorMode}
        acceptLanguage={pageProps?.currentLocale}
        requestId={pageProps?.requestId}
        customerId={pageProps?.dataLayer?.data[0]?.mr_id ?? ''}
        subDirectoryVal={pageProps?.model?.subDirectoryContextPath}
      />
    ),
    {
      emptyLabel: 'Text',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-offers-spa/components/outletofferresults`)(
    props => (
      <OutletOfferResult
        {...props}
        offerId={pageProps.productSpecificResponse.offerId}
        isPreview={pageProps.productSpecificResponse.isPreview}
        isAuthorMode={isAuthorMode}
        acceptLanguage={pageProps?.currentLocale}
        requestId={pageProps?.requestId}
      />
    ),
    {
      emptyLabel: 'Offers Card Carousel',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-offers-spa/components/offerssearchresults`)(
    props => (
      <div className={`${props?.model?.appliedCssClassNames ?? 'mt-5 mb-5'}`}>
        <OffersSearchResults
          {...props}
          isAuthorMode={isAuthorMode}
          acceptLanguage={pageProps?.currentLocale}
          requestId={pageProps?.requestId}
          sessionData={pageProps?.sessionData}
        />
      </div>
    ),
    {
      emptyLabel: 'Offers Search Results',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-offers-spa/components/previewcontainer`)(props => (
    <PreviewContainer
      {...props}
      isAuthorMode={isAuthorMode}
      allowedComponents={allowedComponents}
      isPreview={pageProps?.productSpecificResponse?.isPreview}
    />
  ));
  MapTo(`mi-aem-offers-spa/components/onoffcontainer`)(props => (
    <OnOffContainer
      {...props}
      isAuthorMode={isAuthorMode}
      allowedComponents={allowedComponents}
      offersData={pageProps.productSpecificResponse}
    />
  ));
  MapTo(`mi-aem-offers-spa/components/nearbydestinations`)(props => (
    <div className={`${props?.model?.appliedCssClassNames ?? ''}`}>
      <NearByDestinations
        {...props}
        isAuthorMode={isAuthorMode}
        allowedComponents={allowedComponents}
        isPreview={pageProps?.productSpecificResponse?.isPreview}
        requestId={pageProps?.requestId}
        acceptLanguage={pageProps?.currentLocale}
      />
    </div>
  ));
  MapTo(`mi-aem-offers-spa/components/text`)(props => <OffersAemText {...props} />, {
    emptyLabel: 'Offers AEM Text',
    isEmpty: false,
  });
  MapTo(`mi-aem-offers-spa/components/offers-hero`)(
    props => <OffersHero {...props} offersData={pageProps.productSpecificResponse} />,
    {
      emptyLabel: 'Offers Hero',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-offers-spa/components/mbehero`)(
    props => (
      <div className={`${props?.model?.appliedCssClassNames ?? 'mt-5 mb-5'}`}>
        <OffersMBEHero
          {...props}
          isAuthorMode={isAuthorMode}
          allowedComponents={allowedComponents}
          offersData={pageProps?.productSpecificResponse}
          isUserLoggedIn={pageProps?.isUserLoggedIn}
        />
      </div>
    ),
    {
      emptyLabel: 'Offers Countdown Timer',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-offers-spa/components/offers-searchform`)(
    props => (
      <OffersSearchFormWrapper
        {...props}
        offersApiResponse={pageProps.productSpecificResponse}
        isAuthorMode={isAuthorMode}
        acceptLanguage={pageProps?.currentLocale}
        requestId={pageProps?.requestId}
      />
    ),
    {
      emptyLabel: 'OffersSearchForm',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-offers-spa/components/offers-details`)(
    props => (
      <OfferDetails
        {...props}
        offersData={pageProps.productSpecificResponse}
        isAuthorMode={isAuthorMode}
        acceptLanguage={pageProps?.currentLocale}
      />
    ),
    {
      emptyLabel: 'Offer Details',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-offers-spa/components/offers-cards`)(
    props => (
      <OfferCardCarousel
        {...props}
        offersData={pageProps.productSpecificResponse}
        isAuthorMode={isAuthorMode}
        acceptLanguage={pageProps?.currentLocale}
        requestId={pageProps?.requestId}
        cookie={pageProps?.headersData['cookie']}
      />
    ),
    {
      emptyLabel: 'Offers Card Carousel',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-offers-spa/components/offers-cards-list`)(
    props => (
      <OfferCardListing
        {...props}
        offersData={pageProps.productSpecificResponse}
        isAuthorMode={isAuthorMode}
        acceptLanguage={pageProps?.currentLocale}
        requestId={pageProps?.requestId}
        cookie={pageProps?.headersData['cookie']}
      />
    ),
    {
      emptyLabel: 'Offers Card Listing',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-offers-spa/components/offerscardstiles`)(
    props => <OfferCards {...props} offersData={pageProps.productSpecificResponse} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'Offers Card',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-offers-spa/components/exploredestinations`)(props => (
    <div className={`${props?.model?.appliedCssClassNames ?? 'mt-5 mb-5'}`}>
      <ExploreDestinations {...props} isAuthorMode={isAuthorMode} mbeData={pageProps?.productSpecificResponse} />
    </div>
  ));
  MapTo(`mi-aem-offers-spa/components/offerscardhorizontalmini`)(
    props => (
      <div className={`${props?.model?.appliedCssClassNames ?? 'pb-5'}`}>
        <OfferCardHorizontalMini
          {...props}
          offersData={pageProps.productSpecificResponse}
          isAuthorMode={isAuthorMode}
        />
      </div>
    ),
    {
      emptyLabel: 'Offers Card Horizontal Mini',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-offers-spa/components/offerscardlayered`)(
    props => (
      <div className={`${props?.model?.appliedCssClassNames ?? 'pb-5 mb-5'}`}>
        <OffersCardLayered {...props} isAuthorMode={isAuthorMode} offersData={pageProps.productSpecificResponse} />
      </div>
    ),
    {
      emptyLabel: 'Offers Card Layerd',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-offers-spa/components/offersbannerlayered`)(
    props => (
      <div className={`${props?.model?.appliedCssClassNames ?? ''}`}>
        <OffersBannerLayered {...props} isAuthorMode={isAuthorMode} offersData={pageProps.productSpecificResponse} />
      </div>
    ),
    {
      emptyLabel: 'Offers Banner Layered',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-offers-spa/components/offersherobanner`)(
    props => (
      <div className={`${props?.model?.appliedCssClassNames ?? 'mb-5 pb-0'}`}>
        <OffersHeroBanner {...props} isAuthorMode={isAuthorMode} offersData={pageProps.productSpecificResponse} />
      </div>
    ),
    {
      emptyLabel: 'Offers Hero Banner',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-offers-spa/components/offerscobrandcardhorizontalflexible`)(
    props => (
      <div className={`${props?.model?.appliedCssClassNames ?? 'mb-5'}`}>
        <OffersCobrandCardHorizontalFlexible
          {...props}
          isAuthorMode={isAuthorMode}
          offersData={pageProps.productSpecificResponse}
        />
      </div>
    ),
    {
      emptyLabel: 'Offers Cobrand Card Horizontal Flexible',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-offers-spa/components/offershero`)(
    props => (
      <div className={`${props?.model?.styleclass ?? 'mb-5 pb-5'}`}>
        <OffersHeroV2 {...props} isAuthorMode={isAuthorMode} offersData={pageProps.productSpecificResponse} />
      </div>
    ),
    {
      emptyLabel: 'Offers Hero Banner V2',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-offers-spa/components/offersvariablecolumncontainer`)(props => (
    <div className={`${props?.model?.appliedCssClassNames ?? 'mb-5'}`}>
      <OffersVariableColumnContainer
        {...props}
        offersData={pageProps.productSpecificResponse}
        isAuthorMode={isAuthorMode}
        allowedComponents={allowedComponents}
      />
    </div>
  ));

  MapTo(`mi-aem-offers-spa/components/brandedlogobar`)(props => (
    <div className={`m-container-fullbleed ${props?.model?.appliedCssClassNames ?? 'mt-5 mb-5 inverse fullbleed'}`}>
      <BrandedLogoBar {...props} isAuthorMode={isAuthorMode} />
    </div>
  ));
  MapTo(`mi-aem-offers-spa/components/tabbedproperties`)(props => (
    <div className={`${props?.model?.appliedCssClassNames ?? 'mt-5 mb-5'}`}>
      <TabbedProperties {...props} isAuthorMode={isAuthorMode} mbeData={pageProps?.productSpecificResponse} />
    </div>
  ));

  //Book components
  MapTo(`mcom-book-spa/components/prebooking/hotelheader`)(
    props => (
      <div
        className="brand-css m-container-fullbleed"
        style={{
          'pointer-events': pageProps.productSpecificResponse.isPreview == 'true' ? 'none' : 'auto',
        }}
      >
        <div className={`m-container-fullbleed ${props?.model?.appliedCssClassNames}`}>
          <HotelHeaderComponentEditable
            {...props}
            acceptLanguage={pageProps?.currentLocale}
            enableHQVLink={true}
            isAuthorMode={isAuthorMode}
          />
        </div>
      </div>
    ),
    {
      emptyLabel: 'HotelHeaderComponent',
      isEmpty: false,
    }
  );

  //Homepage components
  MapTo(`mi-aem-homepage-spa/components/content/herobanner`)(
    props => (
      <div className={`${props?.model?.appliedCssClassNames ?? 'mb-5 pb-0'}`}>
        {props.model?.path?.split('/').pop().startsWith('offers') ? (
          <OffersHeroBanner {...props} isAuthorMode={isAuthorMode} offersData={pageProps.productSpecificResponse} />
        ) : (
          <HeroBanner {...props} />
        )}
      </div>
    ),
    {
      emptyLabel: 'Offers Hero Banner',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(props => (
    <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper);
  MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper);

  //Shop components
  MapTo(`mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform`)(
    props => <SearchFormEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'SearchForm',
      isEmpty: false,
    }
  );

  //Mobile Offers Preview Components
  MapTo('mi-aem-common-spa/components/content/appsmallbanner')(
    props => <AppSmallBanner {...props} isAuthorMode={isAuthorMode} offersData={pageProps.productSpecificResponse} />,
    {
      emptyLabel: 'App Small Banner',
      isEmpty: false,
    }
  );

  const existingMappings = Object.keys(AEM_REACT_MAPPING);
  if (allowedComponents) {
    allowedComponents.forEach(mapping => {
      const baseModelPath = '/jcr:content/root/responsivegrid/';
      const componentPath = mapping.path.split(baseModelPath)[1];
      if (existingMappings.indexOf(componentPath) === -1) {
        MapTo(componentPath)(EditableHTLWrapper, {
          emptyLabel: mapping.title,
          isEmpty: false,
        });
      } else {
        console.log('mapping exists', componentPath);
      }
    });
  }
};
